module["exports"] = [
  "####",
  "###",
  "##",
  "#"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/zh_TW/address/building_number.js
// module id = 2862
// module chunks = 2